import React, { useEffect, useState } from 'react';
import { useCliente } from '../../../navigation/context/ClienteContext';
import { FaqService } from '../PortalTransparenciaPage/utils/useServices';
import CollapsibleList from '../CollapsibleList';

export default function Faq() {
  const { identificador } = useCliente();
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    if (identificador) {
      const fetchFaq = async () => {
        const { data } = await FaqService(identificador);
        setFaqs(data.data);
      };
      fetchFaq();
    }
  }, [identificador]);

  return (
    <CollapsibleList
      items={faqs}
      titleField="pergunta"
      contentField="respostaHTML"
      showQuestionIcon={true}
      sortByField="ordemExibicao"
    />
  );
}
